import * as yup from 'yup'

class MarketingSource {
  _id?: string = ''
  name = ''
  active = true
}

const MarketingSourceValidationSchema = yup.object().shape({
  _id: yup.string().matches(/^[a-f\d]{24}$/i, { excludeEmptyString: true }),
  name: yup.string().required('This field is required'),
  active: yup.boolean(),
})

const MarketingSourcesValidationSchema = yup.object().shape({
  marketingSources: yup.array().of(MarketingSourceValidationSchema).min(1),
})

export interface MarketingSources {
  marketingSources: MarketingSource[]
}

export { MarketingSource, MarketingSourcesValidationSchema, MarketingSourceValidationSchema }
